import httpClient from '../http-client'
import Coupon from '../models/coupon'
import CouponForCreate from '../models/for-create/coupons'
import CouponForUpdate from '../models/for-update/coupons'

const getCoupon = async (couponId: string) => {
	const coupon = (await httpClient.get<Coupon>(`coupons/${couponId}`)).data

	return coupon
}

const getAllCoupons = async (filters?: any) => {
	const coupons = (await httpClient.get<any[]>('coupons', { params: filters })).data
	if (coupons && coupons.length) {
		return coupons
	}
}

const createCoupon = async (newCoupon: CouponForCreate) => {
	const createCouponResponse = (await httpClient.post<any>(`coupons/`, newCoupon)).data

	return createCouponResponse
}

const updateCoupon = async (couponId: any, newInfo: CouponForUpdate) => {
	await httpClient.put(`coupons/${couponId}`, newInfo)
}

const deleteCoupon = async (contentId: string) => {
	await httpClient.delete(`coupons/${contentId}`)
}

export { getAllCoupons, deleteCoupon, updateCoupon, createCoupon, getCoupon }
